import React, { Component } from "react";
import SalesUploadBody from "./SalesUploadBody";

class SalesUpload extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <SalesUploadBody />
      </div>
    );
  }
}

export default SalesUpload;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/SalesUpload.js